import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';


export default function ProductListTableHeader(){
  const {pharmaorderObj} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard)
  const {productObj} = useSelector((state)=>state.pharmaslice.productDashboard)
  useEffect(()=>{
  },[])
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
            {pharmaorderObj.id===undefined?<Grid item lg={1} md={1} sm={1} xs={1} ><Typography variant="h5"> Order # </Typography></Grid>:<></>}
            
            <Grid item lg={1} md={1} sm={1} xs={1} ><Typography variant="h5">  # </Typography></Grid>
            <Grid item lg={3} md={3} sm={3} xs={2} ><Typography variant="h5"> Brand </Typography></Grid>
            <Grid item lg={3} md={3} sm={3} xs={2} ><Typography variant="h5"> Customer Status </Typography></Grid>
            <Grid item lg={3} md={3} sm={3} xs={2} ><Typography variant="h5"> Quality Status </Typography></Grid>
            {/* <Grid item lg={1} xs={1} ><Typography variant="h5"> Form </Typography></Grid>
            
            <Grid item lg={1} xs={1} ><Typography variant="h5"> Value </Typography></Grid>
            <Grid item lg={1} xs={1} ><Typography variant="h5"> Status </Typography></Grid> */}
            {/* <Grid item lg={1} xs={1} ><Typography variant="h5"> Design</Typography></Grid> */}
            {/* {pharmaorderObj.id===undefined?
              <Grid item lg={1} xs={1} ><Typography variant="h5"> RM </Typography></Grid>
            :<></>} */}
      </Grid>
      
    )
}